module.exports = {
      id: "icons:star-usage",
      viewBox: "0 0 17 17",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#icons:star-usage",
      toString: function () {
        return this.url;
      }
    }